import React, { useState } from 'react'
import cn from 'classnames'
import { ReactComponent as UnselectedRadioButton } from '../assets/icons/unselected-radio-button-icon.svg'
import { ReactComponent as SelectedRadioButton } from '../assets/icons/selected-radio-button-icon.svg'
import styles from './SelfCheckoutConfig.module.scss'
import Button from '../components/Button'
import VNConcessionsNavBar from '../components/VNConcessionsNavBar'
import Record from '../components/Record'
import { setRoute } from '../VNRoutes/ActionCreators'
import { useDispatch, useSelector } from 'react-redux'
import { getKioskBarcodeScanningEnabled } from '../selectors/config'
import { disableKioskBarcodeScanning, enableKioskBarcodeScanning } from '../actions/config'
import { APPLICATION_STRINGS } from '../strings'
import { SHIFT4_BLUE } from '../styles/constants'
import { clearImageCache } from '../VNImageCache/utils'

const SelfCheckoutConfig = ({ className }) => {
  const classNames = cn(styles.selfCheckoutConfig, className)
  const dispatch = useDispatch()

  const currentKioskBarcodeScanningEnabled = useSelector(getKioskBarcodeScanningEnabled)
  const [kioskBarcodeScanningEnabled, setEnableKioskBarcodeScanning] = useState(currentKioskBarcodeScanningEnabled)

  const scaleSvgIcon = (icon) => {
    return <div className={styles.svg}>{icon}</div>
  }

  const storeSelection = () => {
    if (kioskBarcodeScanningEnabled) {
      dispatch(enableKioskBarcodeScanning())
      return
    }
    dispatch(disableKioskBarcodeScanning())
  }

  const goBack = () => {
    storeSelection()
    dispatch(setRoute('/revenue-center-setup', { fromSelfCheckoutConfig: true }))
  }

  const handleDone = () => {
    storeSelection()
    clearImageCache().finally(() => {
      dispatch(setRoute('/kiosk/attract_loop'))
    })
  }

  return (
    <div>
      <div className={classNames}>
        <VNConcessionsNavBar useSmallTitleFont={true} useHamburgerIcon={true} />
        <div className={styles.header}>Select Self-Checkout Setting</div>
        <div className={styles.container}>
          <div className={styles.options}>
            <Record
              key={APPLICATION_STRINGS.DISABLE_BARCODE_PRODUCT_SCANNING}
              icon={scaleSvgIcon(!kioskBarcodeScanningEnabled ? <SelectedRadioButton /> : <UnselectedRadioButton />)}
              name={APPLICATION_STRINGS.DISABLE_BARCODE_PRODUCT_SCANNING}
              style={{ backgroundColor: !kioskBarcodeScanningEnabled ? SHIFT4_BLUE : undefined }}
              styles={styles}
              onClick={() => {
                setEnableKioskBarcodeScanning(false)
              }}
            />
            <Record
              key={APPLICATION_STRINGS.ENABLE_BARCODE_PRODUCT_SCANNING}
              icon={scaleSvgIcon(kioskBarcodeScanningEnabled ? <SelectedRadioButton /> : <UnselectedRadioButton />)}
              name={APPLICATION_STRINGS.ENABLE_BARCODE_PRODUCT_SCANNING}
              style={{ backgroundColor: kioskBarcodeScanningEnabled ? SHIFT4_BLUE : undefined }}
              styles={styles}
              onClick={() => {
                setEnableKioskBarcodeScanning(true)
              }}
            />
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <Button useMui className={styles.backButton} onClick={goBack}>
            Back
          </Button>
          <Button useMui className={styles.doneButton} onClick={handleDone}>
            Done
          </Button>
        </div>
      </div>
    </div>
  )
}

export default SelfCheckoutConfig
